require('../../modules/es6.symbol');
module.exports = require('../../modules/_core').Symbol['for'];



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/symbol/for.js
// module id = 1053
// module chunks = 168707334958949